<template>
  <div class="address-card"
       :class="{
         'big-card': !isSmallCard,
         'small-card': isSmallCard,
         'small-card-selected': isSmallCard && shippingAddress.isSelected,
         'small-card-unselected': isSmallCard && !shippingAddress.isSelected}"
       @click="onSelected">
    <div class="receiver-telephone">
      <div class="container">
        <span class="receiver">{{shippingAddress.receiver}}</span>
        <span class="telephone">{{shippingAddress.telephone}}</span>
      </div>
      <span class="is-default"
            v-show="shippingAddress.isDefault">默认</span>
    </div>
    <span class="address">{{shippingAddress.totalAddress}}</span>
    <div class="btn-container"
         v-show="!isSmallCard">
      <div class="btn edit-btn"
           @click="editAddress"></div>
      <div class="btn delete-btn"
           @click="deleteAddress"></div>
    </div>
  </div>
</template>

<script >
export default {
  props: {
    shippingAddress: {
      type: Object,
      default() {
        return {
          // 地址id
          id: 0,
          // 省市区id
          areaArr: [0, 0, 0],
          // 姓名
          receiver: '',
          // 详细地址
          totalAddress: '',
          // 编辑地址
          address: '',
          // 联系方式
          telephone: '13574963852',
          // 是否为默认地址
          isDefault: false,
          // 是否被选择
          isSelected: false
        };
      }
    },
    isSmallCard: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    onSelected() {
      this.shippingAddress.isSelected = !this.shippingAddress.isSelected;
      this.$emit('selected', this.shippingAddress);
    },
    editAddress() {
      this.$emit('edit-address', this.shippingAddress);
    },
    deleteAddress() {
      this.$emit('delete-address', this.shippingAddress);
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.address-card {
  box-sizing: border-box;
  margin: 0 26px 20px 0;
  box-sizing: border-box;
  padding: 20px 20px 22px 20px;
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  position: relative;
  &.big-card {
    width: 300px;
    height: 140px;
    background-image: url("../../assets/shipping-address/address_bg_opacity.png");
  }
  &.small-card {
    width: 260px;
    height: 140px;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  &.small-card-selected {
    background-image: url("../../assets/shipping-address/address_bg_active.jpg");
  }
  &.small-card-unselected {
    background-image: url("../../assets/shipping-address/address_bg_unactive.jpg");
  }
  .receiver-telephone {
    padding-bottom: 8px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e4e4e4;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .container {
      .receiver {
        margin-right: 12px;
      }
    }
    .is-default {
      display: inline-flex;
      width: 40px;
      height: 20px;
      justify-content: center;
      align-items: center;
      margin-left: 4px;
      font-size: 12px;
      color: #fff;
      background: #919398;
    }
  }
  .address {
    display: inline-block;
    margin: 6px 0;
  }
  .btn-container {
    position: absolute;
    right: 20px;
    bottom: 10px;
    display: flex;
    justify-content: flex-end;
    .btn {
      padding: 2px;
      height: 14px;
      width: 14px;
      cursor: pointer;
      background-size: 14px 14px;
      background-position: center;
      background-repeat: no-repeat;
    }
    .edit-btn {
      margin-right: 8px;
      background-image: url("../../assets/shipping-address/edit.png");
    }
    .delete-btn {
      background-image: url("../../assets/shipping-address/delete.png");
    }
  }
}
</style>
